import React from 'react';

type Props = {};

export const ScholarshipCard: React.FC<Props> = ({}) => {
    return (
        <div className="profile-card green-theme">
            <div className="title-container">
                <h2 className="title">Scholarships Available</h2>
            </div>
        </div>
    );
};
